import { TOCOrderType, TOCProductCode, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
export const FnOProducts = [
    { title: "NRML", value: "NRML", rank: 1 },
    { title: "MIS", value: "MIS", rank: 2 },
    { title: "BO", value: "BO", rank: 3 },
];
export const FnOOrder = [
    { title: "MARKET", value: "MARKET", rank: 1 },
    { title: "LIMIT", value: "LIMIT", rank: 2 },
    { title: "SL", value: "STOP_LIMIT", rank: 3 },
];
export const FnOValidity = [
    { title: "Day", value: "DAY", rank: 1 },
    { title: "IOC", value: "IOC", rank: 2 },
];
export const setUISectionsFNO = (activeButton) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let tempShowUiSections = {
        showStopLoss: false,
        showTargetPrice: false,
        showTriggerPrice: false,
        showTermsConditions: false,
        disabledLimitInput: false,
    };
    if ((((_a = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === TOCProductCode.MIS ||
        ((_b = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === TOCProductCode.NRML) &&
        (((_c = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === TOCOrderType.MARKET ||
            ((_d = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === TOCOrderType.LIMIT)) {
        if (((_e = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === TOCOrderType.MARKET) {
            tempShowUiSections.disabledLimitInput = true;
        }
    }
    if ((((_f = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === TOCProductCode.MIS ||
        ((_g = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === TOCProductCode.NRML) &&
        ((_h = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === TOCOrderType.SL) {
        tempShowUiSections.showTriggerPrice = true;
    }
    if (((_j = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === TOCProductCode.BO &&
        ((_k = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showTargetPrice = true;
        tempShowUiSections.showStopLoss = true;
        tempShowUiSections.showTermsConditions = true;
    }
    return tempShowUiSections;
};
